module.exports = __webpack_public_path__ + "static/media/dont1.bd88b709.png";